import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Autoplay, Keyboard, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Lazyload
import lazySizes from 'lazysizes';

// PureCounter
import PureCounter from "@srexi/purecounterjs";

// Plyr
import Plyr from 'plyr';
import 'plyr/src/sass/plyr.scss'

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

const setupApp = ()=>
{
    AOS.init();
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // Hero counter
    const pure = new PureCounter({
        formater: 'fa-IR'
    });

    // Introduce section video
    const myVideoPlayer1 = new Plyr('#myVideoPlayer1', {
        ratio: '16:9',
    });

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10,
        autoplay: {
            delay: 4000
        },
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
    });

    let categoriesSwiper = new Swiper("#categoriesSwiper", {
        centeredSlidesBounds: true,
        centeredSlides: true,
        slidesPerView: 1.8,
        // loop: true,
        spaceBetween: 16,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.2,
            },
            1280: {
                slidesPerView: 4,
                enabled: false,
                centeredSlides: false,
                centeredSlidesBounds: false,
            },
        },
    });

    let specialCategoriesSwiper = new Swiper("#specialCategoriesSwiper", {
        modules: [Navigation],
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.2,
            },
            1280: {
                slidesPerView: 4.3,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesSwiperNext",
            prevEl: "#specialCategoriesSwiperPrev",
        },
    });

    let usecase2SwiperSwiper = new Swiper("#usecase2Swiper", {
        modules: [Navigation],
        centeredSlidesBounds: true,
        centeredSlides: true,
        slidesPerView: 3,
        loop: true,
        spaceBetween: 5,
        breakpoints: {
            480: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3.8,
            },
            1024: {
                slidesPerView: 4.5,
            },
            1280: {
                slidesPerView: 6,
                // enabled: false,
                centeredSlidesBounds: false,
                centeredSlides: false,
            },
        },
        navigation: {
            nextEl: "#usecase2SwiperNext",
            prevEl: "#usecase2SwiperPrev",
        },
    });

    let blogSwiper = new Swiper("#blogSwiper", {
        modules: [Navigation,Pagination],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
        pagination: {
            el: "#blogSwiperPagination",
        },
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})

// console.clear();
